
import { Component, Prop, Mixins } from 'vue-property-decorator';
import CalendarProvider from '@/components/hoc/CalendarProvider.vue';
import AvailabilityGrid from '@/components/teams/events/AvailabilityGrid.vue';
import { CalendarEventModel } from '@/models/calendar/CalendarEventModel';
import { AppHostnameMixin, BAIconsMixin, CurrentTeamMixin } from '@/mixins';
import { notificationStore } from '@/store';
import * as Routes from '@/../types/constants/web_client_user.routes';

type ExpandFn = (events: CalendarEventModel[], start: Date, end: Date) => CalendarEventModel[];

@Component({
	components: { CalendarProvider, AvailabilityGrid },
})
export default class TeamAvailabilityView extends Mixins(AppHostnameMixin, BAIconsMixin, CurrentTeamMixin){
	@Prop() teamId: string;

	/** Days of events to show. A negative value looks backwards instead of forwards. */
	range: number = 30;

	get RangeStart(): Date{
		const start = new Date();
		if(this.range < 0) start.setDate(start.getDate() + this.range);
		else start.setHours(0, 0, 0, 0);
		return start;
	}
	get RangeEnd(): Date{
		const end = new Date();
		if(this.range < 0) end.setHours(23, 59, 59, 999);
		else end.setDate(end.getDate() + this.range);
		return end;
	}

	/**
	 * A repeating event arrives as a single record; the calendar provider turns it into one entry
	 * per date it falls on, which is what the grid needs for its columns.
	 */
	expand(computeEventsBetween: ExpandFn, events: CalendarEventModel[]): CalendarEventModel[]{
		if(!computeEventsBetween || !Array.isArray(events)) return [];
		return computeEventsBetween(events, this.RangeStart, this.RangeEnd);
	}

	onReminded(result: { reminded: number }): void{
		const count = result && result.reminded ? result.reminded : 0;
		notificationStore.pushSnackbarSuccess({
			message: count === 1 ? 'Reminder sent' : `${count} reminders sent`,
		});
	}

	backToCalendar(): void{
		this.$router.push({
			name: Routes.TeamDashboardCalendar,
			params: { teamId: this.teamId },
		});
	}
}
